import { Pipe, PipeTransform } from '@angular/core';
import { convertBytesToGiB } from '../utility-functions/notebook-utility';

@Pipe({
  name: 'convertBytesToGiB',
  standalone:true
})
export class ConvertBytesToGiBPipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    if (value === null || value === undefined) return '0';
    const result = convertBytesToGiB(value);
    return result % 1 === 0 ? result.toFixed(0) : result.toFixed(1);
  }
}
